import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';
import { Intersection } from '@splidejs/splide-extension-intersection';
import utils from 'utils';

document.addEventListener('DOMContentLoaded', () => {
  initSliders(); 
});


/* SLIDER DEFAULT SETTINGS */
const speed = 400;
Splide.defaults = {
  type: 'slide',
  speed: speed,
  arrows: true,
  pagination: true,
  paginationKeyboard: true,
  drag: true,
  updateOnMove: true,
  // Images Options
  lazyLoad: 'nearby',

  // Styling
  classes: {
    // Add classes for arrows.
    arrows: 'splide__arrows',
    arrow: 'splide__arrow',
    prev: 'splide__arrow--prev',
    next: 'splide__arrow--next',

    // Add classes for pagination.
    pagination: 'splide__pagination', // container
    page: 'splide__pagination__page', // each button
  },
  video: {
    loop: true,
    mute: true,
    autoplay: true,
    hideControls: true,
    disableOverlayUI: true,
    playerOptions: {
      htmlVideo: {
        preload: true,
        autoplay: true,
        playsInline: true,
        muted: true,
      },
    },
  },
  intersection: {
    rootMargin: '20%',
    inView: {
      autoplay: true,
      video: true,
    },
    outView: {
      autoplay: false,
      video: false,
    },
  },
};

const checkVideo = function (slider, currentSlideIndex) {
    // we need to wait for printing video tag on first slide show. why?
    setTimeout(() => {
      if (!slider) {
        // console.error('Slider element not found.');
        return;
      }
      const slides = slider.querySelectorAll('.splide__slide');
  
      if (slides.length === 0) {
        return; // Exit if no slides are found
      }
  
      const newSlide = slides[currentSlideIndex];
  
      if (!newSlide) {
        return;
      }
  
      const video = newSlide.querySelector('video');
      if (!video) {
        return;
      }
  
      if (utils.mq.sm.matches && video.hasAttribute('autoplay')) {
        video.play();
      }
    }, 500);
  };

const titlesPagination = (slider) => {
  const slides = slider.querySelectorAll('.splide__slide');
  const pagination = slider.querySelector('.splide__pagination'); 
  const pages = slider.querySelectorAll('.splide__pagination__page');

  if (pagination && slides.length !== pages.length) {
    pagination.innerHTML = ''; 
  }

  const updatedPages = slider.querySelectorAll('.splide__pagination__page');
  slides.forEach((slide, index) => {
    const title = slide.querySelector('.splide__tp'); 
    if (title && updatedPages.length > 0) {
      const titleTxt = title.textContent.trim();
      updatedPages[index].innerText = titleTxt;
    }
    
  });
};

const checkSlidesAmount = (slider) => {
  if (slider.querySelectorAll('.splide__slide').length <= 1) {
    slider.classList.add('splide--no-slide');
  }
};

/* EVENTS */

const onMount = function(slider) {
  checkVideo(slider, 0);
  titlesPagination(slider);
  checkSlidesAmount(slider);
};
// function onBeforeSlideChange() {}
const onAfterSlideChange = function(slider, destIndex) {
  checkVideo(slider, destIndex);
};
// when slider resized
const afterSliderResized = (slider) => {
  titlesPagination(slider);
};

document.addEventListener('reviewsRendered', function() {
  initSliders();  // Reinitialize the function for wizville slider
});

export const initSliders = function() {

  /*## DEFAULT SLIDER ##*/

  const sliders = document.querySelectorAll('.splide:not(.splide-sm):not(.splide\\@\\>sm):not(.splide-sync):not(.splide-parent):not(.modal-slideshow):not(.discovery-roll__slider)');
  sliders.forEach((slider) => {
    slider.splide = new Splide(slider);

    /*-- EVENTS --*/
    slider.splide.on('mounted', function() {
      onMount(slider);
    });
    // slider.splide.on('move', function(newIndex, prevIndex, destIndex) {
    //   onBeforeSlideChange();
    // });
    slider.splide.on('moved', function(newIndex, prevIndex, destIndex) {
      onAfterSlideChange(slider, destIndex);
    });
    slider.splide.on('resized', function () {
      afterSliderResized(slider);
    });

    /*-- MOUNT --*/
    slider.splide.mount({ Video, Intersection });
  });

  /*## SM ONLY DEFAULT SLIDER ##*/
  const slidersSm = document.querySelectorAll('.splide-sm:not(.modal-slideshow):not(.splide-sync)');
  slidersSm.forEach((sliderSm) => {
    sliderSm.splide = new Splide(sliderSm);


    /*-- EVENTS --*/
    sliderSm.splide.on('mounted', function() {
      onMount(sliderSm);
    });
    sliderSm.splide.on('moved', function(newIndex, prevIndex, destIndex) {
      onAfterSlideChange(sliderSm, destIndex);
    });

    /*-- MOUNT / UNMOUNT --*/

    if (utils.mq.sm.matches) {
      if (!sliderSm.splide.state.is(3)) {
        sliderSm.splide.mount({ Video, Intersection });
      }
    }

    utils.mq.sm.addListener(e => {
      if (e.matches) {
        if (!sliderSm.splide.state.is(3)) {
          sliderSm.splide.mount({ Video, Intersection });
        }
      } else {
        if (sliderSm.splide.state.is(3)) {
          sliderSm.splide.destroy(true);
        }
      }
    });
  });

  /*## UNDER SM ONLY DEFAULT SLIDER ##*/
  const slidersUpToSm = document.querySelectorAll('.splide\\@\\>sm:not(.modal-slideshow):not(.splide-sync)');
  slidersUpToSm.forEach((sliderUpToSm) => {
    sliderUpToSm.splide = new Splide(sliderUpToSm);

    /*-- EVENTS --*/
    sliderUpToSm.splide.on('mounted', function() {
      onMount(sliderUpToSm);
    });
    sliderUpToSm.splide.on('moved', function(newIndex, prevIndex, destIndex) {
      onAfterSlideChange(sliderUpToSm, destIndex);
    });

    /*-- MOUNT / UNMOUNT --*/

    if (!utils.mq.sm.matches) {
      sliderUpToSm.splide.mount({ Video, Intersection })
    }

    utils.mq.sm.addListener(e => {
      if (!e.matches) {
        sliderUpToSm.splide.mount({ Video, Intersection });
      } else {
        sliderUpToSm.splide.destroy(true);
      }
    });
  });

  /*## SLIDER SYNC ##*/
  const slidersSync = document.querySelectorAll('.splide-sync:not(.splide-sm):not(.modal-slideshow)');
  slidersSync.forEach(thumbnailsSlider => {

    const mainSlider = thumbnailsSlider.previousElementSibling;
    mainSlider.splide = new Splide(mainSlider);
    thumbnailsSlider.splide = new Splide(thumbnailsSlider);

    /*-- EVENTS --*/
    mainSlider.splide.on('mounted', function() {
      onMount(mainSlider);
    });
    mainSlider.splide.on('moved', function(newIndex, prevIndex, destIndex) {
      onAfterSlideChange(mainSlider, destIndex);
    });

    /*-- MOUNT / SYNC --*/
    thumbnailsSlider.splide.mount();
    mainSlider.splide.sync(thumbnailsSlider.splide);
    mainSlider.splide.mount({ Video, Intersection });
  });

  /*## SM ONLY SLIDER SYNC ##*/

  const slidersSyncSm = document.querySelectorAll('.splide-sync.splide-sm:not(.modal-slideshow)');

  slidersSyncSm.forEach((thumbnailsSlider) => {
    const mainSlider = thumbnailsSlider.previousElementSibling;
    mainSlider.splide = new Splide(mainSlider);
    thumbnailsSlider.splide = new Splide(thumbnailsSlider);

    /*-- EVENTS --*/
    mainSlider.splide.on('mounted', function() {
      onMount(mainSlider);
    });
    mainSlider.splide.on('moved', function(newIndex, prevIndex, destIndex) {
      onAfterSlideChange(mainSlider, destIndex);
    });

    /*-- MOUNT / UNMOUNT / SYNC --*/

    if (utils.mq.sm.matches) {
      // thumbnailsSlider.splide.mount();
      // mainSlider.splide.sync(thumbnailsSlider.splide);
      // mainSlider.splide.mount({ Video, Intersection });
      if (!thumbnailsSlider.splide.state.is(3)) {
        thumbnailsSlider.splide.mount();
      }
      if (!mainSlider.splide.state.is(3)) {
        mainSlider.splide.sync(thumbnailsSlider.splide);
        mainSlider.splide.mount({ Video, Intersection });
      }
    }

    utils.mq.sm.addListener(e => {
      // if (e.matches) {
      //   thumbnailsSlider.splide.mount();
      //   mainSlider.splide.sync(thumbnailsSlider.splide);
      //   mainSlider.splide.mount({ Video, Intersection });
      // } else {
      //   thumbnailsSlider.splide.destroy(true);
      //   mainSlider.splide.destroy(true);
      // }
      if (e.matches) {
        if (!thumbnailsSlider.splide.state.is(3)) {
          thumbnailsSlider.splide.mount();
        }
        if (!mainSlider.splide.state.is(3)) {
          mainSlider.splide.sync(thumbnailsSlider.splide);
          mainSlider.splide.mount({ Video, Intersection });
        }
      } else {
        if (thumbnailsSlider.splide.state.is(3)) {
          thumbnailsSlider.splide.destroy(true);
        }
        if (mainSlider.splide.state.is(3)) {
          mainSlider.splide.destroy(true);
        }
      }
    });
  });

  document.querySelectorAll('.discovery-roll:not(.js-discovery-roll)').forEach((paragraph) => {
    paragraph.classList.add('js-discovery-roll');
    const sliderEl = paragraph.querySelector('.discovery-roll__slider.splide');
    
    if (sliderEl) {
      // Check if the slider has already been initialized
      if (!sliderEl.classList.contains('is-initialized')) {
        const slider = new Splide(sliderEl, {
          type: 'loop',
        });
  
        // Mount
        slider.mount();
  
        // Add a class if the slider is initialized
        sliderEl.classList.add('is-initialized');
        
        // Now that it's mounted, check if it's in the proper state
        // After mounting, proceed with event listeners and state checks
        if (slider.state) {
          // Ensure slider is mounted and not in an error state
          if (!slider.state.is(Splide.STATES.DESTROYED)) {
            paragraph.querySelectorAll('.discovery-roll-full').forEach((thumb) => {
              thumb.addEventListener('click', () => {
                // Navigate slider to the clicked thumbnail
                slider.go(Array.from(thumb.parentElement.children).indexOf(thumb));
              });
            });
          }
      }
    }
  }
  });
}

initSliders();

/* LISTEN FOR RELOAD AFTER AJAX CALL */
document.addEventListener('reloadSlideshow', (e) => {
  initSliders();
}, false);
